import {
  ENROLLMENT_COMMON_MESSAGES,
  ENROLLMENT_VALIDATION_MESSAGES
} from '../../../constants/enrollmentContent'
import {
  normalizeStateCode,
  normalizeStateName
} from '../../../components/eligibilitySteps/states'
import type { ApplicationFormData, FieldErrors } from '../types'
import { deriveAddressComponents } from './index'

export const getCommonFieldErrors = (
  formData: ApplicationFormData,
  addressStateRestriction = ''
): FieldErrors => {
  const errors: FieldErrors = {}

  if (!formData.firstName.trim()) {
    errors.firstName = ENROLLMENT_VALIDATION_MESSAGES.firstNameRequired
  }

  if (!formData.lastName.trim()) {
    errors.lastName = ENROLLMENT_VALIDATION_MESSAGES.lastNameRequired
  }

  if (!formData.phoneNumber.trim()) {
    errors.phoneNumber = ENROLLMENT_VALIDATION_MESSAGES.phoneRequired
  }

  if (!formData.email.trim()) {
    errors.email = ENROLLMENT_VALIDATION_MESSAGES.emailRequired
  }

  if (!formData.addressLine1.trim()) {
    errors.addressLine1 = ENROLLMENT_VALIDATION_MESSAGES.addressRequired
  }

  if (!formData.city.trim()) {
    errors.city = ENROLLMENT_VALIDATION_MESSAGES.cityRequired
  }

  if (!formData.state.trim()) {
    errors.state = ENROLLMENT_VALIDATION_MESSAGES.stateRequired
  }

  if (!formData.zipCode.trim()) {
    errors.zipCode = ENROLLMENT_VALIDATION_MESSAGES.zipRequired
  }

  const normalizedAddressStateRestriction = normalizeStateCode(addressStateRestriction)
  const normalizedAddressState = normalizeStateCode(formData.state)
  if (
    normalizedAddressStateRestriction &&
    normalizedAddressState &&
    normalizedAddressState !== normalizedAddressStateRestriction
  ) {
    errors.state = `Please enter an address in ${normalizeStateName(normalizedAddressStateRestriction)}.`
  }

  if (!formData.termsAccepted) {
    errors.termsAccepted = ENROLLMENT_COMMON_MESSAGES.termsRequired
  }

  return errors
}

export const hasCommonRequiredApplicationFields = (formData: ApplicationFormData) =>
  formData.firstName.trim() !== '' &&
  formData.lastName.trim() !== '' &&
  formData.phoneNumber.trim() !== '' &&
  formData.email.trim() !== '' &&
  formData.addressLine1.trim() !== '' &&
  formData.termsAccepted

export const canRegisterApplication = (formData: ApplicationFormData) =>
  hasCommonRequiredApplicationFields(formData)

export const getRegisterFieldErrors = (
  formData: ApplicationFormData,
  addressStateRestriction = ''
) => {
  const addressComponents = deriveAddressComponents(formData.addressLine1, {
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode
  })

  return getCommonFieldErrors(
    { ...formData, ...addressComponents },
    addressStateRestriction
  )
}
